import { mapGetters, mapMutations, mapState } from 'vuex'
import constants from './../../lib/constants'
const { filters } = constants.leaseitnow

const mixinsLeaseItNow = {
  methods: {
    getCarsPayload() {
      return {
        type: this.getTypeToken(this.type),
        manufacturers: this.brandsArgs,
        models: this.modelsArgs,
        editions: this.editionsArgs,
        fuelType: this.fuelsArgs,
        bodyType: [],
        transmission: this.transmissions.length ? this.transmissions[0] : '',
        priceMin: this.prices.length ? this.prices[0] : 0,
        priceMax: this.prices.length ? this.prices[1] : 0,
      }
    },

    getTypeToken() {
      const { _private, commercial } = filters.typeOptions
      return this.type ? commercial : _private
    },

    decodeTypeToken(value) {
      const { commercial } = filters.typeOptions
      return value === commercial
    },

    hideHeaderRequestOfferButton() {
      const requestOfferButton = document.querySelector(
        '.s-header__tools .btn-request-offer'
      )
      if (requestOfferButton) {
        requestOfferButton.style.display = 'none'
      }
    },

    showHeaderRequestOfferButton() {
      const requestOfferButton = document.querySelector(
        '.s-header__tools .btn-request-offer'
      )
      if (requestOfferButton) {
        requestOfferButton.removeAttribute('style')
      }
    },

    ...mapMutations([
      'setField',
      'addRecordToCompare',
      'removeRecordFromCompare',
    ]),
  },
  computed: {
    ...mapGetters(['getField', 'getFiltersCount']),
    ...mapState([
      'type',
      'brands',
      'brandsArgs',
      'models',
      'modelsArgs',
      'editions',
      'editionsArgs',
      'fuels',
      'fuelsArgs',
      'bodyTypes',
      'transmissions',
      'prices',
      'deposit',
      'extras',
      'extrasOptionIds',
      'numOfPayments',
      'annualKm',
      'buybackAmount',
      'buyback',

      'rentalPrice',
      'vat',
      'finalPrice',
      'extraPrice',

      'recordsCompare',
    ]),
  },
}

export default mixinsLeaseItNow
